/* eslint-disable @typescript-eslint/no-empty-function */
import { DashboardCard, Flex, P, SquareIcon, StyledContainer } from 'styling/GlobalStyles'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { HrDashboardInnerWidgetContainer } from '../HrDashboard.styled'
import { WarningTriangleIcon } from 'assets/icons/WarningTriangleIcon'

export const HrAlertsAndSuggestionsWidget = ({
  modalOpen,
  removeWidget,
  onDragOver,
  onDragStart,
  onDragDrop,
}: IWidget) => {
  const Row = ({ alert }: { alert?: boolean }) => {
    return (
      <StyledContainer width='100%' height='auto'>
        <Flex gap='1rem' center>
          <SquareIcon color={alert ? '#FF4F46' : '#ff9900'} height='30px'>
            {WarningTriangleIcon}
          </SquareIcon>
          <Flex column>
            <BodyText>{alert ? 'Performance Drop' : 'Leave Request'}</BodyText>
            <OtherText>
              {alert
                ? 'Approval pending: Ethan Walker requests leave from 5–9 Oct.'
                : 'Approval pending: Ethan Walker requests leave from 5–9 Oct.'}
            </OtherText>
          </Flex>
        </Flex>
      </StyledContainer>
    )
  }

  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => {
        onDragStart('alerts', 2)
      }}
      onDrop={onDragDrop}
      onDragEnd={(e) => {
        e.preventDefault()
      }}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('alerts')
      }}
      width='1fr'
      style={{ gridArea: 'alerts', cursor: modalOpen ? 'grab' : 'normal' }}
      noPadding
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('alerts')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <TitleText weight='bold' style={{ paddingInline: '1rem', paddingTop: '1rem' }}>
        ALERTS & REQUESTS
      </TitleText>
      <HrDashboardInnerWidgetContainer padding='1rem' style={{ height: '100%' }} overflow>
        <Flex width='100%' column height='100%' gap='0.375rem'>
          <Row alert />
          <Row />
        </Flex>
      </HrDashboardInnerWidgetContainer>
    </DashboardCard>
  )
}
